import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, CircularProgress, Box } from "@mui/material";
import { useClinicTheme } from "../../theme";
import { DIALOG_TITLES } from "./constants";
import { FormDatePicker, FormTextField, parseYMD, toYMD } from "../../components/atoms";

import { COLORS } from "../../styles/uiConstants";

export default function UserActionDialog({
  open,
  dialogType,
  selectedUser,
  reason,
  onReasonChange,
  endDate,
  onEndDateChange,
  onClose,
  onConfirm,
  isLoading,
}) {
  const { palette } = useClinicTheme();
  const title = DIALOG_TITLES[dialogType] || "";

  return (
    <Dialog open={open} onClose={!isLoading ? onClose : undefined} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: palette.primary, fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent>
        {selectedUser && (
          <Box>
            <Alert severity="info" sx={{ mb: 3 }}>
              <strong>{selectedUser.name} {selectedUser.surname}</strong> kullanıcısının hesabını{" "}
              {dialogType === "suspend" && "askıya almak"}
              {dialogType === "freeze" && "dondurmak"}
              {dialogType === "disable" && "devre dışı bırakmak"}
              {dialogType === "activate" && "aktifleştirmek"} istiyorsunuz.
            </Alert>

            {dialogType !== "activate" && (
              <FormTextField
                palette={palette}
                fullWidth label="Sebep" multiline rows={3}
                value={reason} onChange={(e) => onReasonChange(e.target.value)}
                required sx={{ mb: 3 }} placeholder="Lütfen işlem sebebini belirtin..."
              />
            )}

            {(dialogType === "suspend" || dialogType === "freeze") && (
              <FormDatePicker
                fullWidth
                label="Bitiş Tarihi (Opsiyonel)"
                value={endDate ? toYMD(endDate) : ""}
                onChange={(v) => onEndDateChange(v ? parseYMD(v) : null)}
                minDate={toYMD(new Date())}
                sx={{ mb: 3 }}
              />
            )}

            {dialogType === "activate" && (
              <>
                {selectedUser.clinic?.status === "inactive" && (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    <strong>Dikkat:</strong> Bu kullanıcının bağlı olduğu klinik
                    (&quot;{selectedUser.clinic.name}&quot;) şu an pasif.
                  </Alert>
                )}
                <Alert severity="success">
                  Bu işlem kullanıcının hesabını aktifleştirecek ve tüm kısıtlamaları kaldıracaktır.
                </Alert>
              </>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1.5 }}>
        <Button onClick={onClose} disabled={isLoading} sx={{ fontWeight: 800, textTransform: "none", color: COLORS.error, "&:hover": { bgcolor: COLORS.errorLightest } }}>
          İptal
        </Button>
        <Button
          onClick={onConfirm} variant="contained"
          disabled={isLoading || (dialogType !== "activate" && !reason?.trim())}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
          sx={{
            fontWeight: 800, textTransform: "none", borderRadius: 2,
            bgcolor: dialogType === "activate" ? COLORS.successDark : COLORS.error,
            "&:hover": { bgcolor: dialogType === "activate" ? COLORS.successDarker : COLORS.errorDark },
          }}
        >
          {isLoading ? "İşleniyor..." : title}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
